// extracted by mini-css-extract-plugin
export default {"menuBtn":"HamburgerMenu_menuBtn__WZvfU","menuBtnBurger":"HamburgerMenu_menuBtnBurger__zv5Z9","open":"HamburgerMenu_open__TADU8"};